import React, { FC, ReactNode } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@raisin/components-lib';
import * as S from './styles';

interface BankAffiliateBannerProps {
  title: string;
  subtitle?: ReactNode | string;
  listItems: string[];
  imageSrc: string;
}

export const BankAffiliateBanner: FC<BankAffiliateBannerProps> = ({
  title,
  subtitle,
  listItems = [],
  imageSrc,
}) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <S.BannerContainer>
      <S.BannerContent container>
        <S.TitleText color="white" variant="h3">
          {title}
        </S.TitleText>
        {subtitle && (
          <S.SubtitleContainer data-testid="hero-subtitle">
            <S.SubtitleText color="white">{subtitle}</S.SubtitleText>
          </S.SubtitleContainer>
        )}
        {listItems?.length > 0 && (
          <S.ListContainer>
            {listItems.map((item: string, index) => (
              <S.ListItem key={index} data-testid="hero-list-item">
                <S.CheckmarkIcon src="/cp_assets/checkmark.svg" alt="checkmark-icon" />
                <S.ListItemText color="white">{item}</S.ListItemText>
              </S.ListItem>
            ))}
          </S.ListContainer>
        )}
      </S.BannerContent>

      {isDesktop ? (
        <S.LGCircleContent>
          <S.LGCircle>
            <S.Logo alt="bank logo" src={imageSrc} />
          </S.LGCircle>
        </S.LGCircleContent>
      ) : (
        <S.SMCircle>
          <S.SMLogoContainer>
            <S.Logo alt="bank logo" src={imageSrc} />
          </S.SMLogoContainer>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 50"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path d="M 0,0 A 50,50 0 0,0 100,0 Z" fill="#ffffff" />
          </svg>
        </S.SMCircle>
      )}
    </S.BannerContainer>
  );
};
